<!-- HTML -->
<template>
  <div
    class="flex center-xs top-xs feed-component h-100 re-center-roundtable-feed-component"
  >
    
      <div>
        <roundtable-settings-in-feed
          v-bind:key="'roundtable-settings-in-feed'"
          v-if="hasTeacherPermissionsInCourse"
        />
        <prompt-in-feed
          v-bind:key="'prompt-in-feed'"
          @toggleEditPrompt="edit_prompt = !edit_prompt"
          style="overflow-wrap: break-word"
        />
        <div v-if="no_submissions" class="no-responses-message">
          Student responses will populate here. There are none yet.
        </div>
      </div>
      <!-- Dialogs -->
      <div v-if="edit_prompt" class="transparent-modal">
        <prompt-in-feed-modal
          v-bind:key="'prompt-in-feed'"
          @toggleEditPrompt="edit_prompt = !edit_prompt"
          :editPrompt="edit_prompt"
          style="overflow-wrap: break-word"
        />
      </div>
      <!-- Confirmation modal for delete submission -->
      <div>
        <dialog-delete-confirm
          v-if="show_delete_submission_modal"
          @close="show_delete_submission_modal = false"
          @actionConfirmed="deleteSubmission"
          optionalText="Submission"
        />
      </div>
      <!-- Confirmation modal for hiding submission -->
      <pl-confirm
        :typeConfirm="false"
        confirmText="Hide"
        class="tl"
        v-if="show_hide_submission_modal"
        @confirm="confirmHideSubmission"
        @close="show_hide_submission_modal = false"
      >
        <div style="width: 90%; margin-left: auto; margin-right: auto">
          <p class="pl-title bold">Hide Submission</p>
          <p>
            This will hide the submission and associated comments from
            participants in the RoundTable. Only you and the original poster can
            see it from now on.
          </p>
          <p>You can undo this at any time.</p>
        </div>
      </pl-confirm>
      <!-- DELETE COMMENT -->
      <pl-dialog
        v-if="show_delete_comment_dialog"
        @close="show_delete_comment_dialog = false"
        :maxWidth="'500px'"
        header="Are you sure you want to DELETE this comment?"
      >
        <pl-input
          :labelText="label_confirm_msg"
          :errorMessage="error_message_computed"
          @keyup.native.enter="
            closeDialog('confirm-delete-comment', 'delete-comment')
          "
          v-model="confirm"
        >
        </pl-input>
        <div class="row end-xs">
          <pl-button class="pl-primary-font" @click.native="cancelDelete()"
            >CANCEL</pl-button
          >
          <pl-button
            class="pl-primary-font"
            @click.native="
              closeDialog('confirm-delete-comment', 'delete-comment')
            "
            >OK</pl-button
          >
        </div>
      </pl-dialog>
      <!-- Comment Hiding Dialog -->
      <pl-confirm
        :typeConfirm="false"
        confirmText="HIDE"
        class="tl"
        v-if="show_hide_comment_modal"
        @confirm="hideComment"
        @close="show_hide_comment_modal = false"
      >
        <div style="width: 90%; margin-left: auto; margin-right: auto">
          <p class="pl-title bold">Hide Comment</p>
          <p>
            This will hide the comment and associated replies from participants
            in the RoundTable. Only you and the original poster can see it from
            now on.
          </p>
          <p>You can undo this at any time.</p>
        </div>
      </pl-confirm>
      <!-- FLAG DIALOG -->
      <pl-dialog
        v-if="show_flag_dialog"
        @close="show_flag_dialog = false"
        header="Are you sure you would like to flag this?"
      >
        <div class="row end-xs">
          <pl-button class="pl-primary" @click.native="show_flag_dialog = false"
            >CANCEL</pl-button
          >
          <pl-button
            class="pl-primary"
            @click.native="closeDialog('confirm-flag', 'flag')"
            >OK</pl-button
          >
        </div>
      </pl-dialog>
      <!-- View Criteria -->
      <pl-dialog
        v-if="show_assessment_modal"
        @close="show_assessment_modal = false"
        maxHeight="80%"
        width="80%"
        max-width="700px"
      >
        <div
          v-if="Number(getCurrentRT.point_cap) > 0"
          class="pl-subheading start-xs"
          style="padding: 10px 30px"
        >
          Max Score: {{ Number(getCurrentRT.point_cap) }}
        </div>
        <div class="row no-margin start-xs scroll" style="padding: 10px 20px">
          <div
            class="col-xs-6 start-xs"
            style="padding: 10px"
            v-for="point in getCurrentRT.points_settings.peer_rewards"
            :key="point.tag"
          >
            <span class="pl-title">
              {{ point.title }}
            </span>
            <div class="pl-body-2 row no-margin start-xs middle-xs">
              <p>
                {{
                  typeof point.description === 'object'
                    ? point.description.join('. ')
                    : point.description
                }}
              </p>
            </div>
          </div>
        </div>
      </pl-dialog>
      <!-- Delete online saved feedback -->
      <!-- <pl-confirm
        v-if="show_confirm_delete_feedback"
        confirmColor="pl-ruby"
        confirmText="DELETE"
        @close="show_confirm_delete_feedback = false"
        @confirm="confirmDeleteSavedFeedback"
        :message="`Delete this saved feedback template?`"
      >
        <div class="mh4 mb4 tc ph4 pl-subheading">
          <p class="pl-body-1 ma0 italics">
            It will be permanently removed from this course.
          </p>
        </div>
      </pl-confirm> -->
      <dialog-delete-confirm
        v-if="show_confirm_delete_feedback"
        @close="show_confirm_delete_feedback = false"
        @actionConfirmed="confirmDeleteSavedFeedback"
        :header="'Delete this saved feedback template'"
        :subHeader="'It will be permanently removed from this course.'"
      />
      <saved-feedback-modal
        v-if="show_saved_feedback_modal"
        :feedbackID="feedback_id"
        :feedbackContent="feedback_content"
        :focusOnMounted="true"
        :isEditFeedback="set_edit_saved_feedback"
        :rtType="'online'"
        @modalFeedbackClosed="closeSavedFeedbackModal"
      />
      <import-saved-feedback-modal
        v-if="show_import_feedback_modal"
        @modalFeedbackClosed="show_import_feedback_modal = false"
        :onlineRT="true"
      />
      <create-new-point-modal
        :activityType="activityType"
        :tag="selected_point_tag"
        :rts="roundtables_with_point"
        v-if="show_point_creation_modal"
        @close="show_point_creation_modal = false"
      />
      <anonymous-character-description-modal
        :anonymous_identity="identity_to_show"
        @close="show_anonymous_description_modal = false"
        v-if="show_anonymous_description_modal"
      />
      <dialog-delete-confirm
        v-if="show_delete_point_modal"
        @close="show_delete_point_modal = false"
        @actionConfirmed="deleteAssessmentPoint"
        optionalText="Are you sure you want to delete this Point?"
      />
      <template v-if="show_alert_assessment_changing">
        <pl-dialog :maxWidth="'600px'" :padding="'2em'" class="center-xs">
          <div style="position: absolute; right: 0; top: 0">
            <pl-button
              @click.native="closeAssessmentChangingAlert"
              style="min-width: 0"
            >
              <strong class="f4">X</strong>
            </pl-button>
          </div>
          <div class="header pv3">
            <span class="pl-secondary b" style="font-size: 24px">
              Heads up!
            </span>
          </div>
          <div class="ph3" style="text-align: justify">
            <p>
              Changing (or deleting) this assessment criteria for this
              RoundTable will change (or delete) it for all of the other
              RoundTables in this course that also use this criteria:
            </p>
            <ul>
              <li
                class="b"
                v-for="roundtable in displayCriteriaRts"
                :key="roundtable.id"
              >
                {{ roundtable.title }}
              </li>
            </ul>
          </div>
          <div class="pv2">
            <pl-button
              class="pl-primary"
              style="font-size: 16px"
              @click.native="closeAssessmentChangingAlert"
            >
              Okay, Got it.
            </pl-button>
          </div>
        </pl-dialog>
      </template>
      <!-- View Unsubmitted -->
      <pl-dialog v-if="show_unsubmitted_modal" height="80%" maxWidth="630px">
        <pl-button
          @click.native="show_unsubmitted_modal = false"
          style="position: absolute; top: 12px; right: 12px; margin: 0"
          class="pl-icon"
        >
          <i class="fa fa-close fa-lg"></i>
        </pl-button>
        <div class="flex">
          <div class="avatar-circle avatar-size ml3">
            <img :src="unsubmitted_response.user.avatar_url" alt="avatar" />
          </div>
          <div class="tl ml3">
            <p class="ma0 pl-title">{{ unsubmitted_response.user.name }}</p>
            <div><p class="ma0 ruby-text i">Unsubmitted</p></div>
          </div>
        </div>
        <div>
          <div class="unsubmitted-text-section">
            <section
              class="prompt-response ph3 tl"
              style="font-weight: 500"
              v-html="unsubmitted_response.draft_response"
            />
          </div>
          <div class="i pl3 tl mt4" style="font-size: 12px; color: #273248">
            {{ unsubmitted_response.word_count }} Words
          </div>
        </div>
      </pl-dialog>
    </div>
  </div>
</template>

<!-- JS -->
<script lang="babel">

  import { mapGetters } from 'vuex';
  import SubmissionCard from '../../components/submissionCard/submissionCard';
  import ByPassCard from '../../components/byPassCard.vue';
  import { EventBus } from 'utils/event-bus';
  import RoundtableSettingsInFeed from './roundtableSettingsInFeed.vue';
  import PromptInFeed from './promptInFeed.vue';
  import PromptInFeedModal from './promptInFeedModal.vue';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';
  import store from 'store';
  import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
  import AnonymousCharacterDescriptionModal from 'components/modals/anonymousCharacterDescriptionModal';
  import createNewPointModal from 'components/createNewPointModal.vue';
  import SavedFeedbackModal from 'components/modals/savedFeedbackModal';
  import ImportSavedFeedbackModal from 'components/modals/importSavedFeedbackModal';
  export default {
    components: {
      SubmissionCard,
      PromptInFeed,
      RoundtableSettingsInFeed,
      ByPassCard,
      PromptInFeedModal,
      dialogDeleteConfirm,
      AnonymousCharacterDescriptionModal,
      createNewPointModal,
      SavedFeedbackModal,
      ImportSavedFeedbackModal
    },
    watch: {
      '$route.query'() {
        const { submissionId, tab } = this.$route.query;
        if (submissionId && tab) {
          const index = this.orderedSubmissions.findIndex(s => s.id === submissionId);
          this.scrollToSubmission(index, submissionId,tab);
        }
      },
      show_delete_point_modal(){
        if (this.show_delete_point_modal === false){
          this.delete_point_index = null;
          this.roundtables_with_point = [];
          this.selected_point_tag = null;
        }
      },
      show_point_creation_modal(){
        if (this.show_point_creation_modal === false){
          this.roundtables_with_point = [];
          this.selected_point_tag = null;
        }
      },
    },
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getSubmissionsBySubmitStatus',
        'getProfile',
        'getCurrentRT',
        'getCourseDetail'
      ]),
      submitted_submission_list() {
        let all_submissions = [];
        let student_submissions = [];
        if (this.submitted_submission_student && this.submitted_submission_student.length) {
          this.submitted_submission_student.forEach(item => {
            if (!item.is_hidden ||
              (item.is_hidden && this.hasTeacherPermissionsInCourse) ||
              this.ownSubmission(item.id)
            ) {
              student_submissions.push(item);
            }
          });
        }
        if(this.by_pass_submission_list && this.by_pass_submission_list.length) {
          all_submissions = student_submissions.concat(this.by_pass_submission_list);
          return all_submissions;
        }
        all_submissions = student_submissions;
        return all_submissions;
      },
      submitted_submission_student() {
        return this.getSubmissionsBySubmitStatus.submitted.filter(student => !student.teacher_submission);
      },
      submitted_submission_teacher() {
        if(this.hasTeacherPermissionsInCourse){
          return this.getSubmissionsBySubmitStatus.submitted.filter(teacher => (teacher.teacher_submission));
        } else {
          return this.getSubmissionsBySubmitStatus.submitted.filter(teacher => (teacher.teacher_submission && !teacher.is_hidden ));
        }
      },
      by_pass_submission_list() {
        return this.getSubmissionsBySubmitStatus.by_passed;
      },
      no_submissions() {
        return this.submitted_submission_list && this.submitted_submission_list.length === 0 && !this.submitted_submission_teacher;
      },
      displayCriteriaRts(){
        return this.roundtables_with_point.filter(x => x.id !== this.getCurrentRT.id);
      },
      orderedSubmissions() {
        let sorted_list=[];
        switch (this.sortSubmissionsBy) {
          case 'date-asc':
            this.submitted_submission_list.sort((a, b) => {
              if(a.start_date && b.start_date) {
                return new Date(a.created_at) - new Date(b.created_at);
              }
            });
            sorted_list = this.submitted_submission_teacher.concat(this.submitted_submission_list);
            return sorted_list;
          case 'date-desc':
            this.submitted_submission_list.sort((a, b) => {
              if(a.start_date && b.start_date) {
                return new Date(b.created_at) - new Date(a.created_at);
              }
            });
            sorted_list = this.submitted_submission_teacher.concat(this.submitted_submission_list);
            return sorted_list;
          case 'student-desc':
            this.submitted_submission_list.sort((a, b) => {
              if(a.start_date && b.start_date) {
                return a.user.name.localeCompare(b.user.name);
              }
            });
            sorted_list = this.submitted_submission_teacher.concat(this.submitted_submission_list);
            return sorted_list;
          case 'student-asc':
            this.submitted_submission_list.sort((a, b) => {
              if(a.start_date && b.start_date) {
                return b.user.name.localeCompare(a.user.name);
              }
            });
            sorted_list = this.submitted_submission_teacher.concat(this.submitted_submission_list);
            return sorted_list;
        }
      },
      error_message_computed() {
        return this.error_message;
      },
      responses() {
        let array = [];
        this.orderedSubmissions.forEach((s) => {
          if (s.start_date) {
            array.push(s.id);
          }
        });
        return array;
      },
    },
    data() {
      return {
        edit_prompt: false,
        sortSubmissionsBy: 'date-asc',
        opened_submissions: {},
        entry: {},
        identity_to_show: {},
        show_delete_submission_modal: false,
        show_hide_submission_modal: false,
        show_delete_comment_dialog: false,
        show_hide_comment_modal: false,
        show_import_feedback_modal:false,
        show_saved_feedback_modal: false,
        show_flag_dialog: false,
        show_anonymous_description_modal: false,
        show_assessment_modal: false,
        show_point_creation_modal: false,
        activityType: null,
        type: null,
        submissionToDelete: {},
        submissionIdToHide: null,
        confirm: '',
        error_message: '',
        toast_msg: '',
        label_confirm_msg: 'Type "confirm" into the field to continue',
        feedback_content: '',
        feedback_id: '',
        set_edit_saved_feedback: false,
        show_confirm_delete_feedback: false,
        show_unsubmitted_modal: false,
        unsubmitted_response: {},
        selected_point_tag: null,
        show_delete_point_modal: false,
        delete_point_index: null,
        roundtables_with_point:[],
        show_alert_assessment_changing: false,
      };
    },
    methods: {
      nextUnopenedSubmissionID(submissionID,array){
        return this.nextSubmissionId(submissionID,array);
      },
      nextSubmissionId(submissionID,array){
        for (let index=0; index<= array.length-1; index +=1 ){
          if (!this.opened_submissions[array[index]]){
            return array[index];
          }
        }
        return array[0];
      },
      ownSubmission(id) {
        return this.getProfile.my_rt_user_details.submission_id === id;
      },
      scrollToSubmission(index, submissionId, tab = 'comments') {
        return this.$store
          .dispatch('submissionClicked', submissionId)
          .then(() =>{
          if (tab === 'assessment'){
            this.$store.dispatch('getSubmissionSummary', submissionId);
          }
           this.$refs.scroller.scrollToItem(index);
           })
          .then(() => {
            setTimeout(() => {
              const nodeList = document.querySelectorAll(
                `#feed-${submissionId} > div.flex.justify-end`
              );
              let submissionToScrollToElement;
              if (nodeList.length === 1) {
                [submissionToScrollToElement] = nodeList;
              } else {
                submissionToScrollToElement = Array.from(nodeList).find(
                  (node) =>
                    node.parentElement
                      .closest('.vue-recycle-scroller__item-view')
                      .style.transform.split('translateY(')[1]
                      .split('px)')[0] >= 0
                );
              }
              if (submissionToScrollToElement) {
                submissionToScrollToElement.scrollIntoView({
                  block: 'start',
                  inline: 'nearest',
                  behavior: 'smooth',
                });
              }
            }, 0);
          });
      },
     openSubmissionTab(submission_id) {
        const scroller = this.$refs.scroller;
        if (scroller) {
          const nodeList = document.querySelectorAll(
            `#submission-tab-row-${submission_id}`
          );
          let submissionToScrollToElement;
          if (nodeList.length === 1) {
            [submissionToScrollToElement] = nodeList;
          } else {
            submissionToScrollToElement = Array.from(nodeList).find(
              (node) =>
                node.parentElement
                  .closest('.vue-recycle-scroller__item-view')
                  .style.transform.split('translateY(')[1]
                  .split('px)')[0] >= 0
            );
          }
          if (submissionToScrollToElement) {
            submissionToScrollToElement.scrollIntoView({
              block: 'start',
              inline: 'nearest',
              behavior: 'smooth',
            });
          }
        }
      },
      showDeleteSubmissionModal(submission) {
        this.submissionToDelete = submission;
        this.show_delete_submission_modal = true;
      },
      deleteSubmission() {
        this.$store.dispatch('deleteSubmission', this.submissionToDelete.id).then(()=>{
          if (this.submissionToDelete.is_model_response) {
          this.$store
            .dispatch('toggleModelResponse', this.submissionToDelete.id)
            .catch(console.error);
        }
          this.submissionToDelete = null;
        });

      },
      showHideSubmissionModal(submission) {
        if (submission.is_hidden) {
          this.submissionIdToHide = submission.id;
          this.confirmHideSubmission(false, this.submissionIdToHide);
        } else {
          this.show_hide_submission_modal = true;
          this.submissionIdToHide = submission.id;
        }
      },
      confirmHideSubmission(hide = true) {
        this.$store.dispatch('toggleHideSubmission', {
          payload: {
            is_hidden: hide,
          },
          submission_id: this.submissionIdToHide,
        }).then(this.submissionIdToHide = null);
      },
      openAnonymityModal(anonymous_identity) {
        this.show_anonymous_description_modal = true;
        this.identity_to_show = anonymous_identity;
      },
      goToStudentSubmissionPage() {
        this.$router.push({
          name: 'roundtable.submit',
          params: this.$route.params,
        });
      },
      cancelDelete(){
        this.show_delete_comment_dialog = false;
        this.error_message = '';
      },
      closeDialog(ref, action) {
        // finish flagging
        if (action === 'flag') {
          this.flagToggle(this.entry.id);
          this.show_flag_dialog = false;
          return;
        }
        if (action === 'delete-comment' && this.confirm === 'confirm') {
          this.confirm = '';
          this.show_delete_comment_dialog = false;

          roundtableService
            .deleteComment(this.entry.id)
            .then(() => {
              EventBus.$emit('toast-msg', 'Comment successfully deleted');
              store.dispatch('updateComment', {
                delete: true,
                id: this.entry.id, // comment to delete
                comment_id: this.entry.comment_id, // if comment is a reply, will have comment_id
                submission_id: this.entry.submission_id,
              });
            })
            .then(() => {
              store.dispatch('deleteComment', this.entry);
              this.entry.is_model_submission
                ? this.$store.dispatch(
                    'toggleModelResponse',
                    this.entry.submission_id
                  )
                : null;
            })
            .catch(console.error);
        }
        // set error msg with confirm is not filled
        if (action === 'delete-comment' && this.confirm !== 'confirm') {
          this.confirm = '';
          this.error_message =
            'Please type "confirm" in the input box to continue';
          return;
        }
        this.confirm = '';
      },
      flagToggle(entryID) {
        if (this.type === 'comment') {
          roundtableService
            .flagComment(this.getProfile.id, entryID)
            .then((res) => {
              if (res.data.comment_id === null) {
                store.dispatch('updateCommentFlag', res.data);
              } else {
                store.dispatch('updateReplyFlag', res.data);
              }
              const flagged = res.data.flagged_by.includes(this.getProfile.id);
              const toast_msg = flagged
                ? 'Flag successful! Your teacher will be notified.'
                : 'Unflag successful!';
              EventBus.$emit('toast-msg', toast_msg);
            })
            .catch((err) => {
              const msg =
                err.response.data.message ||
                'Something went wrong, please try again.';
              EventBus.$emit('toast-msg', msg);
            });
        } else if (this.type === 'submission') {
          roundtableService.flagSubmission(this.getProfile.id, entryID);
        }
        this.type = null;
      },
      handleCommentClick() {
        if (this.entry.is_hidden) {
          this.hideComment(false);
        } else {
          this.show_hide_comment_modal = true;
        }
      },
      hideComment(hide = true) {
        this.$store.dispatch('toggleHideComment', {
          payload: {
            is_hidden: hide,
          },
          comment_id: this.entry.id,
        });
      },
      showAssessmentModal() {
        this.show_assessment_modal = true;
      },
      showImportFeedback() {
        this.show_import_feedback_modal = true;
      },
      showSavedFeedback() {
        this.show_saved_feedback_modal = true;
      },
      confirmDeleteSavedFeedback() {
        this.$store
          .dispatch('deleteFeedback', {
            course_id: this.getCourseDetail.id,
            feedback_id: this.feedback_to_delete.id,
            onlineRT: true,
          })
          .then(() => {
            this.feedback_to_delete = {};
            this.show_confirm_delete_feedback = false;
          });
      },
      closeSavedFeedbackModal() {
        this.show_saved_feedback_modal = false;
        this.set_edit_saved_feedback = false;
        this.feedback_id = '';
        this.feedback_content = '';
      },
      async deleteAssessmentPoint(){
        let clonedCoursePointSettings = this.getCourseDetail.points_settings.peer_rewards.slice();
        clonedCoursePointSettings.splice(this.delete_point_index,1);
        let payload = [];
        if (this.roundtables_with_point.length){
          for (let i=0; i < this.roundtables_with_point.length; i += 1){
            const rt = this.getCourseDetail.roundtables.find(r => r.id === this.roundtables_with_point[i].id);
            const index_rt = rt.points_settings.peer_rewards.findIndex(x => x.tag === this.selected_point_tag);
            const peer_rewards = rt.points_settings.peer_rewards.slice();
            peer_rewards.splice(index_rt,1);
            payload.push({ id: rt.id , peer_rewards});
          }
        }
        if (payload.length){
          await this.$store.dispatch('updateRTsCriteria',{
            id: this.getCourseDetail.id,
            criterias : payload,
            activityType: 'written',
          });
          const currentRTChanged = payload.find(x => x.id === this.getCurrentRT.id);
          if (currentRTChanged){
            const {peer_rewards} = currentRTChanged;
            const cloned_rt = Object.assign({}, this.getCurrentRT);
            cloned_rt.points_settings = { peer_rewards};
            this.$store.commit('UPDATE_RT_DETAILS', cloned_rt);
          }
        }
        this.$store
          .dispatch('updateCourseDetail', {
            id: this.getCourseDetail.id,
            points_settings: { peer_rewards: clonedCoursePointSettings },
          }).then(() => {
              this.show_delete_point_modal = false;
              EventBus.$emit('toast-msg','Assessment Criteria Point has been deleted.');
          });
      },
      checkRoundtablesWithPoint(tag){
        this.selected_point_tag = tag;
        const { roundtables } = this.getCourseDetail;
        let result = [];
        for (let index= 0; index< roundtables.length; index += 1){
          const rt = roundtables[index];
          const { peer_rewards } = rt.points_settings;
          const has_point = peer_rewards.find(p => p.tag === this.selected_point_tag);
          if (has_point){
            result.push({title: rt.title, id: rt.id});
          }
        }
        this.roundtables_with_point = result;
        const only_current_roundtable = this.roundtables_with_point.length === 1 ? this.roundtables_with_point[0].id === this.getCurrentRT.id : false;
        if (this.roundtables_with_point.length && !only_current_roundtable){
          this.show_alert_assessment_changing = true;
        }
        return result;
      },
      closeAssessmentChangingAlert(){
        this.show_alert_assessment_changing = false;
        if (this.delete_point_index){
          this.show_delete_point_modal = true;
        }
        else{
         this.show_point_creation_modal = true;
        }
      }
    },
    created() {
      const subsIDs = this.orderedSubmissions.map(s => s.id);
      subsIDs.forEach(subID => {
        this.opened_submissions[subID] = false;
      });
    },
    mounted() {
      this.$nextTick(() => {
        EventBus.$emit('feed-is-mounted');
      });

      const focus_tinymce = () => {
        setTimeout(() => {
          const editor = window.tinymce.get('editor');
          if (editor) {
            editor.execCommand('mceFocus', true, 'editor');
          } else {
            focus_tinymce();
          }
        }, 1000);
      };
      if (this.$route.query.user_created && this.hasTeacherPermissionsInCourse) {
        this.edit_prompt = true;
        focus_tinymce();
      }
      EventBus.$on('nextSubmission',(current_submissionID) => {
        // reorder array
        const subsIDs = this.orderedSubmissions.map(s => s.id);
        let newArray = [];
        const submissionID = subsIDs.filter(id => id === current_submissionID)[0];
        const index = subsIDs.indexOf(submissionID);
        newArray = subsIDs.splice(index,subsIDs.length).concat(subsIDs.splice(0,index));
        let nextSubmissionId = this.nextUnopenedSubmissionID(current_submissionID,newArray);
        EventBus.$emit('openNextSubmission',nextSubmissionId);
        this.opened_submissions[nextSubmissionId] = true;

      });
      EventBus.$on('sort-submissions', (event) => this.sortSubmissionsBy = event);

      EventBus.$on('scrollToSubmission', (submissionId) => {
        const index = this.orderedSubmissions.findIndex(s => s.id === submissionId);
        this.scrollToSubmission(index, submissionId);
      });

      EventBus.$on('goToStudentSubmissionPage', this.goToStudentSubmissionPage);

      EventBus.$on('deleteComment', (type, entry) => {
        this.entry = entry;
        type === 'comment' ? (this.show_delete_comment_dialog = true) : null;
      });

      EventBus.$on('handleComment', (entry) => {
        this.entry = entry;
        this.handleCommentClick();
      });

      EventBus.$on('flagToggle', (entry, type, value) => {
        this.show_flag_dialog = value;
        this.entry = entry;
        this.type = type;
      });

      EventBus.$on('showPointCreationModal', (value,tag) => {
        this.activityType = value;
        if (tag) {
          this.checkRoundtablesWithPoint(tag);
          this.selected_point_tag = tag;
        }
        if (!this.show_alert_assessment_changing){
          this.show_point_creation_modal = true;
        }
      });

      EventBus.$on('editSavedFeedback', (value) => {
        this.feedback_id = value.feedback_id;
        this.feedback_content = value.feedback_content;
        this.show_saved_feedback_modal = true;
        this.set_edit_saved_feedback = true;
      });

      EventBus.$on('deleteSavedFeedback', (value) => {
        this.feedback_to_delete = value;
        this.show_confirm_delete_feedback = true;
      });

      EventBus.$on('showUnsubmitted', (submission)=>{
        this.show_unsubmitted_modal = true;
        this.unsubmitted_response = submission;
      });
      EventBus.$on('delete-assessment-point',(tag) =>{
        this.delete_point_index = this.getCourseDetail.points_settings.peer_rewards.findIndex(x => x.tag == tag);
        this.checkRoundtablesWithPoint(tag);
        if (!this.show_alert_assessment_changing){
          this.show_delete_point_modal = true;
        }
      });
     if(this.$route.query.submissionId){
        const index = this.orderedSubmissions.findIndex(s => s.id === this.$route.query.submissionId);
        this.scrollToSubmission(index, this.$route.query.submissionId)
        .then(this.$router.replace({ query: {} }));
      }
    },
    beforeDestroy() {
      EventBus.$off('nextSubmission');
      EventBus.$off('scrollToSubmission');
      EventBus.$off('goToStudentSubmissionPage');
      EventBus.$off('deleteComment');
      EventBus.$off('handleComment');
      EventBus.$off('flagToggle');
      EventBus.$off('editSavedFeedback');
      EventBus.$off('deleteSavedFeedback');
      EventBus.$off('showUnsubmitted');
      EventBus.$off('showPointCreationModal');
      EventBus.$off('delete-assessment-point');
      EventBus.$off('sort-submissions');
    },
  };
</script>

<!-- CSS -->
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';

  .main-container
    position: relative;
    height: 100%

  .re-center-roundtable-feed-component {
    padding-right: 260px;
    position: inherit;
    height: 100%;
    @media (max-width: 1450px) {
      padding-right: 0px;
    }
  }
  .feed-component {
    .edit-roundtable-button {
      color: pl-charcoal;
      font-size: 12px;
      margin: none;
    }
  }

  .feed-card
    background: #fff
    max-width: 680px
    margin-right: auto
    margin-left: auto
    padding: 20px 0
    // We can not use margins in feed card, it will conflict with the virtual scroller calcs, use padding

  .observer
    margin-right: auto
    margin-left: auto
    max-width: 680px

  .feed-title {
    color: #808284
    margin: 10px
  }
  .feed-divider {
    max-width: 680px
    width: 100%
    height: 50px
    margin: 1em auto
  }
  .loading-comments-screen {
    font-size: 30px
    position: fixed
    z-index: 1
    top: 50%
  }
  .no-responses-message {
    border: 2px solid #e6e7e7
    padding: 30px 0 30px 0
    max-width: 680px
    margin: 1em auto
    font-weight: 400
  }
  .scroller
    height: 100%;

  .transparent-modal
    left: 0
    top: 0
    display: block
    position: fixed
    z-index: 998
    width: 100%
    height: 100%
    overflow-y: hidden
    background: rgba(0,0,0,0.2)

  .scroll
    height: calc(100vh - 250px)
    overflow: auto

  .ruby-text
    color: pl-ruby

  .avatar-size
    width: 40px
    height: 40px
    img
      height: 100%

  .avatar-circle
    border-radius: 50%
    background-color: pl-fog
    border: 1px solid alpha(pl-slate, 0.3)

  .unsubmitted-text-section
    height:calc(80vh - 130px)
    overflow-y: scroll

  ::-webkit-scrollbar {
    display: block;
    width: 10px
    -webkit-appearance: none;
  }
</style>



// WEBPACK FOOTER //
// feed.vue?6d68188d